import { Component } from '@angular/core';

@Component({
  selector: 'app-doc-content',
  templateUrl: './doc-content.component.html',
  styleUrls: ['./doc-content.component.css']
})
export class DocContentComponent {

}
